<template>
  <div class="receipt-content" style="font-family: Monospace">
    <div>
      <p class="text-center">
        <span style="text-transform: uppercase">
          {{ receiptData.outlet && receiptData.outlet.name }}
          {{ receiptData.outlet && receiptData.outlet.code }}
        </span>
      </p>
      <hr class="line2" />
      <table class="table table-borderless">
        <th></th>
        <tr v-if="receiptData.invoice && receiptData.invoice.uniqueCode">
          <td>NOMOR LAMA</td>
          <td>: {{ receiptData.invoice.uniqueCode }}</td>
        </tr>
        <tr v-if="receiptData.invoice && receiptData.invoice.old_invoice">
          <td>NOMOR LAMA</td>
          <td>: {{ receiptData.invoice.old_invoice }}</td>
        </tr>
        <tr>
          <td>NOMOR</td>
          <td>: {{ receiptData.invoice && receiptData.invoice.number }}</td>
        </tr>
        <tr>
          <td>TANGGAL</td>
          <td>
            : {{ formatDate(receiptData.invoice && receiptData.invoice.date) }}
          </td>
        </tr>
      </table>
    </div>

    <div>
      <p class="alncenter p-m-2">DETAIL TRANSAKSI</p>
      <table
        class="table table-borderless"
        v-for="(an_item, k) in receiptData.transactionItems || []"
        :key="k"
      >
        <th></th>
        <tr>
          <td>{{ an_item.item_code }}</td>
          <td>{{ an_item.item_name }}</td>
        </tr>
        <tr>
          <td colspan="2" class="alnleft">
            {{ an_item.qty }} x {{ an_item.init_price | number }}
          </td>
          <td>=</td>
          <td class="alnright">
            {{ (an_item.qty * an_item.init_price) | number }}
          </td>
        </tr>
        <tr v-if="an_item.special_discount > 0">
          <td colspan="2" class="alnleft" style="padding-left: 25px">
            Special Disc
          </td>
          <td>=</td>
          <td class="alnright">
            -{{
              ((an_item.special_discount - an_item.discount) * an_item.qty)
                | number
            }}
          </td>
        </tr>
        <tr v-if="an_item.discount > 0">
          <td colspan="2" class="alnleft" style="padding-left: 25px">
            Disc
            {{ ((an_item.discount / an_item.init_price) * 100) | number }}%
          </td>
          <td>=</td>
          <td class="alnright">
            -{{ (an_item.discount * an_item.qty) | number }}
          </td>
        </tr>
      </table>
      <table class="table table-borderless p-m-2">
        <th></th>
        <tr>
          TOTAL QTY:
          {{
            totals.totalQty
          }}
          PCS
        </tr>
      </table>

      <hr class="line5" />
      <table class="table table-borderless" style="width: 100%">
        <th></th>
        <tr>
          <td>SUBTOTAL</td>
          <td colspan="4"></td>
          <td></td>
          <td>=</td>
          <td></td>
          <td class="alnright">
            {{ totals.subTotalPrice | number }}
          </td>
        </tr>
        <tr v-if="totals.diskonItemTotal > 0">
          <td>DISKON ITEM</td>
          <td colspan="4"></td>
          <td></td>
          <td>=</td>
          <td></td>
          <td class="alnright">-{{ totals.diskonItemTotal | number }}</td>
        </tr>
        <tr v-if="totals.discountTransaction > 0">
          <td>
            DISKON MEMBER
            {{
              Math.ceil(
                (totals.discountTransaction / totals.subTotalPrice) * 100
              ) | number
            }}%
          </td>
          <td colspan="4"></td>
          <td></td>
          <td>=</td>
          <td></td>
          <td class="alnright">-{{ totals.discountTransaction | number }}</td>
        </tr>
        <tr v-if="totals.specialDiscount > 0">
          <td>SPECIAL DISC</td>
          <td colspan="4"></td>
          <td></td>
          <td>=</td>
          <td></td>
          <td class="alnright">-{{ totals.specialDiscount | number }}</td>
        </tr>
        <tr v-if="receiptData.vouchers && receiptData.vouchers[0]">
          <td>{{ receiptData.vouchers[0].payment_method }}</td>
          <td colspan="4"></td>
          <td></td>
          <td>=</td>
          <td></td>
          <td class="alnright">-{{ totals.voucherPaymentMethod | number }}</td>
        </tr>
      </table>
      <hr class="line5" />
      <table class="table table-borderless" style="width: 100%">
        <th></th>
        <tr>
          <td>GRAND TOTAL</td>
          <td colspan="4"></td>
          <td></td>
          <td>=</td>
          <td></td>
          <td class="alnright">
            {{
              (totals.subTotalPrice -
                totals.discountTransaction -
                totals.diskonItemTotal -
                totals.voucherPaymentMethod)
                | number
            }}
          </td>
        </tr>
        <tr
          v-for="item in receiptData.payments || []"
          :key="item.payment_method"
        >
          <td>{{ item.payment_method }}</td>
          <td colspan="4"></td>
          <td></td>
          <td>=</td>
          <td></td>
          <td class="alnright">{{ item.total_amount | number }}</td>
        </tr>
        <tr v-if="totals.infaq > 0">
          <td>INFAQ</td>
          <td colspan="4"></td>
          <td></td>
          <td>=</td>
          <td></td>
          <td class="alnright">-{{ totals.infaq | number }}</td>
        </tr>
        <tr v-if="totals.roundUp > 0">
          <td>PEMBULATAN</td>
          <td colspan="4"></td>
          <td></td>
          <td>=</td>
          <td></td>
          <td class="alnright">-{{ totals.roundUp | number }}</td>
        </tr>
        <tr>
          <td>KEMBALIAN</td>
          <td colspan="4"></td>
          <td></td>
          <td>=</td>
          <td></td>
          <td class="alnright">
            {{ totals.kembalian | number }}
          </td>
        </tr>
      </table>
      <hr class="line5" />
      <table class="table table-borderless">
        <th></th>
        <p style="margin-bottom: 0.5rem">
          KASIR : {{ cashierName }} <br />
          <span v-if="salesPersonName">Pramuniaga : {{ salesPersonName }}</span>
        </p>
        <p v-if="totals.totalAllDiscount + totals.specialDiscount > 0">
          SELAMAT ANDA BERHEMAT SEBESAR
        </p>
        <p
          style="margin-bottom: 0.5rem; margin-top: -0.5rem"
          v-if="totals.totalAllDiscount + totals.specialDiscount > 0"
        >
          {{
            (totals.voucherPaymentMethod +
              totals.diskonItemTotal +
              totals.discountTransaction +
              totals.specialDiscount +
              totals.roundUp)
              | currency
          }}
        </p>
      </table>
      <hr
        class="line5"
        style="margin-top: 3.8rem"
        v-if="giftEligable != null && giftEligable.point != 0"
      />
      <table
        class="table table-borderless"
        v-if="giftEligable != null && giftEligable.point != 0"
      >
        <th></th>
        <div style="margin-bottom: 0.5rem">
          <p style="font-size: 20px; margin-left: 9rem"><b>SELAMAT..</b></p>
          <p style="margin-top: -1.5rem">
            <br />
            <b style="font-size: 18px">ANDA MENDAPATKAN HADIAH BELANJA</b>
            <br />
            <b style="font-size: 18px">POINT {{ giftEligable.point }}</b>
            <br />
            <barcode
              v-if="receiptData.invoice && receiptData.invoice.number"
              v-model="receiptData.invoice.number"
              :options="barcodeOptions"
              :displayValue="false"
            ></barcode>
          </p>
          <div style="margin-top: -1rem">
            <p>Silahkan tukarkan kupon ke stand</p>
            <p>hadiah yang telah disediakan..</p>
          </div>
        </div>
      </table>
    </div>
    <div style="display: flex; justify-content: center">
      ----------------TERIMAKASIH----------------
    </div>
  </div>
</template>

<script>
import receiptService from '@/services/receiptService'
import { formatDate as formatDateUtil } from '@/utils/dateUtils'

export default {
  name: 'ReceiptContent',
  props: {
    receiptData: {
      type: Object,
      required: false,
      default: () => ({
        outlet: {},
        invoice: {},
        transaction: {},
        transactionItems: [],
        payments: [],
        vouchers: [],
        cashier: {},
        salesPerson: {}
      })
    },
    giftEligable: {
      type: Object,
      default: null
    }
  },
  computed: {
    totals() {
      if (
        !this.receiptData ||
        !this.receiptData.transactionItems ||
        !Array.isArray(this.receiptData.transactionItems)
      ) {
        return {
          totalQty: 0,
          subTotalPrice: 0,
          totalAllDiscount: 0,
          diskonItemTotal: 0,
          specialDiscount: 0,
          discountTransaction: 0,
          infaq: 0,
          roundUp: 0,
          totalPaymentAmount: 0,
          voucherPaymentMethod: 0,
          kembalian: 0,
          grandTotal: 0
        }
      }
      return receiptService.calculateReceiptTotals(this.receiptData)
    },
    cashierName() {
      if (!this.receiptData || !this.receiptData.cashier) return ''
      return receiptService.formatCashierName(
        this.receiptData.cashier.name || ''
      )
    },
    salesPersonName() {
      if (!this.receiptData || !this.receiptData.salesPerson) return ''
      const name = this.receiptData.salesPerson.name
      return name && name.length > 0
        ? receiptService.formatSalesPersonName(name)
        : ''
    },
    barcodeOptions() {
      return {
        height: 75,
        textAlign: 'left',
        text: ' '
      }
    }
  },
  methods: {
    formatDate(date) {
      return formatDateUtil(date, 'DD-MM-YYYY HH:mm:ss')
    }
  }
}
</script>

<style scoped lang="scss">
.receipt-content {
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  font-family: Monospace;
}

.alnright {
  text-align: right;
}

.alncenter {
  text-align: center;
}

.alnleft {
  text-align: left;
}

.line2 {
  height: 0px;
  border: 2px dashed #8c8b8b;
}

.line5 {
  background-color: #fff;
  border-top: 2px dashed #8c8b8b;
}

.table-borderless {
  th,
  td,
  thead th,
  tbody + tbody {
    border: 0;
  }
}

table {
  empty-cells: show;
  width: 100%;
  line-height: 1.2em;
}

p,
table {
  margin: 0 0 0.5rem 0;
}
</style>
